module.exports = __webpack_public_path__ + "img/reentryHUB-inverse@2x.c593a3b2.png";